module.exports = __webpack_public_path__ + "static/media/IMG_4899.c508c335.JPG";